// extracted by mini-css-extract-plugin
export var emptyState = "_67-d";
export var statCard = "_67-c";
export var table = "_67-0";
export var tableCell = "_67-4";
export var tableCellClickable = "_67-5 _67-4";
export var tableCellDefault = "_67-6 _67-4";
export var tableCellEmpty = "_67-8";
export var tableCellWithValue = "_67-7";
export var tableContainer = "_67-e";
export var tableHeaderWeight = "_67-1";
export var tableHeaderZone = "_67-2";
export var tableRowHeader = "_67-3";
export var viewModeButton = "_67-9";
export var viewModeButtonActive = "_67-a _67-9";
export var viewModeButtonInactive = "_67-b _67-9";